import { CSSProperties, useState } from 'react'
import ToggleBtnGroup from '../atoms/ToggleBtnGroup'

type Val = {
  showRx?: boolean
  summaryOnly?: boolean
  weeklyFaxReport?: boolean
  faxReports?: boolean
}

interface IProps {
  value: Val
  onChange: (pref: any) => void
}

const styles: Record<string, CSSProperties> = {
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: '15px',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
}

const ReportPreferenceOptions = ({ value = {}, onChange: onChangeProp }: IProps) => {
  const [pref, setPref] = useState(value)

  const onChange = (key: string, value: string | boolean) => {
    if ('summaryOnly' === key) {
      value = 'SUMMARY' === value
    } else if ('showRx' === key) {
      value = 'OFF' === value
    } else if ('weeklyFaxReport' === key) {
      value = 'ENABLED' === value
    } else if ('faxReports' === key) {
      value = 'ENABLED' === value
    }
    onChangeProp({ [key]: value })
    setPref((state) => ({ ...state, [key]: value }))
  }

  return (
    <div style={styles.row}>
      <div style={styles.col}>
        <div style={styles.col}>
          <ToggleBtnGroup
            options={[
              { key: 'SUMMARY', name: 'Summary' },
              { key: 'DETAILED', name: 'Detailed' },
            ]}
            value={pref?.summaryOnly ? 'SUMMARY' : 'DETAILED'}
            onChange={(view) => onChange('summaryOnly', view)}
          />
        </div>
        <div style={styles.col}>
          <ToggleBtnGroup
            options={[
              { key: 'OFF', name: 'Show RX' },
              { key: 'ON', name: 'Show Guidelines' },
            ]}
            value={pref?.showRx ? 'OFF' : 'ON'}
            onChange={(showRx) => onChange('showRx', showRx)}
          />
        </div>
      </div>
      <div style={styles.col}>
        <div style={styles.col}>
          <ToggleBtnGroup
            options={[
              { key: 'ENABLED', name: 'Fax Reports' },
              { key: 'DISABLED', name: 'No Fax Reports' },
            ]}
            value={pref?.faxReports ?? true ? 'ENABLED' : 'DISABLED'}
            onChange={(faxReports) => onChange('faxReports', faxReports)}
          />
        </div>
        <div style={styles.col}>
          <ToggleBtnGroup
            options={[
              { key: 'ENABLED', name: 'Weekly Fax Report' },
              { key: 'DISABLED', name: 'No Weekly Fax' },
            ]}
            value={pref?.weeklyFaxReport ? 'ENABLED' : 'DISABLED'}
            onChange={(weeklyFaxReport) => onChange('weeklyFaxReport', weeklyFaxReport)}
          />
        </div>
      </div>
    </div>
  )
}

export default ReportPreferenceOptions
